import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { user_type, Apitoken, Authtoken } from "../Global";
import customers_access from "../customers_access.json";
import axios from "../api/axios";

const CustomerSidebar = () => {
  const location = useLocation();
  const { pathname } = location;
  const [openMenus, setOpenMenus] = useState({});
  const [manuModules, setManuModules] = useState([]);

  const role_id = localStorage.getItem("role_id");
  const menu_modules = localStorage.getItem("menu_modules");
  const side_bar = menu_modules ? JSON.parse(menu_modules) : [];

  // Set initial menu modules based on user role
  useEffect(() => {
    if (role_id === "3") {
      const hasAccess = customers_access.some(menu => menu.slug === pathname);
      if (!hasAccess) {
        // window.location.href = "/customer-index"; // Uncomment if needed
      }
      setManuModules(customers_access);
    } else {
      setManuModules(side_bar);
    }
  }, [role_id, menu_modules, pathname]);

  // Authentication check
  useEffect(() => {
    if(user_type != 'customer'){
      axios.post("/customerportal/user-profile", {}, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.code !== 200) {
         window.location.href = "/customerportal/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
   
  }, []);

  // Handle mini-sidebar expand/collapse on hover
  useEffect(() => {
    const handleMouseOver = (e) => {
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn")?.offsetParent !== null
      ) {
        const isSidebar = e.target.closest(".sidebar");
        if (isSidebar) {
          document.body.classList.add("expand-menu");
        } else {
          document.body.classList.remove("expand-menu");
        }
      }
    };

    document.addEventListener("mouseover", handleMouseOver);
    return () => document.removeEventListener("mouseover", handleMouseOver);
  }, []);

  // Determine which menus should be open based on current path
  useEffect(() => {
    // Initialize an empty object for open menus
    const newOpenMenus = {};
    
    // Find which parent menu contains the current path
    manuModules.forEach((module) => {
      // Check if this is a main menu item that matches the current path
      if (pathname === module.slug) {
        newOpenMenus[module.name] = true;
      }
      
      // Check if any submenu item matches the current path
      if (module.inner && module.inner.length > 0) {
        const hasActiveChild = module.inner.some(submenu => 
          pathname === submenu.slug || pathname.includes(submenu.slug)
        );
        
        if (hasActiveChild) {
          newOpenMenus[module.name] = true;
        }
      }
    });
    
    // Handle special case for Settings pages
    const pathSegments = pathname.split("/").filter(Boolean);
    const currentPage = pathSegments[0];
    
    const settingsPages = [
      "users", "users-add", "users-edit", "users-view",
      "payment-terms", "payment-terms-add", "payment-terms-edit",
      "called-contacts"
    ];
    
    if (settingsPages.includes(currentPage)) {
      newOpenMenus["Settings"] = true;
    }
    
    setOpenMenus(newOpenMenus);
  }, [pathname, manuModules]);

  // Toggle menu open/close
  const handleMenuToggle = (menuName) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  return (
    <div className="sidebar customer-portal-sidebar" id="sidebar" >
      <Scrollbars>
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul className="sidebar-vertical">
              <li className="menu-title"><span>MAIN MENU</span></li>
              
              {manuModules.map((module) => (
                module.inner && module.inner.length > 0 ? (
                  <li className={`submenu ${openMenus[module.name] ? 'active' : ''}`} key={module.slug}>
                    <Link
                      to="#"
                      className={openMenus[module.name] ? "subdrop active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        handleMenuToggle(module.name);
                      }}
                    >
                      <i className={module.icon} /> <span>{module.name}</span>
                      <span className="menu-arrow" />
                    </Link>
                    <ul style={{ display: openMenus[module.name] ? "block" : "none" }}>
                      {module.inner.map((submenu) => (
                        <li key={submenu.slug}>
                          <Link 
                            to={submenu.slug} 
                            className={pathname === submenu.slug || pathname.includes(submenu.slug) ? "active" : ""}
                          >
                            {submenu.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li key={module.slug} className={pathname === module.slug ? "active" : ""}>
                    <Link to={module.slug}>
                      <i className={module.icon} /> <span>{module.name}</span>
                    </Link>
                  </li>
                )
              ))}
            </ul>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};

export default CustomerSidebar;